import { createSelector } from "@reduxjs/toolkit";

import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys, IPlace } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userAddressesSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userAddress) as IPlace[]
);

const dataUserAddressesSelector = createSelector(dataSelector, data => data.userAddress);

export const userAddressSelectorCreator = (id: string) =>
  createSelector(dataUserAddressesSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_ADDRESS(id)];
    return item ? buildSingleItem(item) : undefined;
  });
